// Re-export from the refactored component
export { ChatSidebarTabs } from './ChatSidebarTabs/index.js';
export type { ChatSidebarTabsProps } from './ChatSidebarTabs/types.js';
